import React, { FC } from 'react'
import { Trans } from '@lingui/macro'
import { AnalyticsHeader } from '../AnalyticsHeader'
import CertificationsOverviewTable from './CertificationsOverviewTable'
import { AnalyticsFiltersEnum } from '../constants'

interface IProps {
  showFilterPanel?: boolean
}

const Certifications: FC<IProps> = ({ showFilterPanel }: IProps) => {
  return (
    <div>
      <AnalyticsHeader
        showFilterPanel={showFilterPanel}
        activeFilters={[
          AnalyticsFiltersEnum.INCLUDE_ARCHIVED,
          AnalyticsFiltersEnum.DATE_FILTER
        ]}
      >
        <Trans>Certifications</Trans>
      </AnalyticsHeader>

      <CertificationsOverviewTable />
    </div>
  )
}

export default Certifications
